import {
  ButtonComponent,
  ButtonHeight,
  ButtonTheme,
} from '@myre/ui-primitive-components';

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  input,
  Output,
} from '@angular/core';

@Component({
  selector: 'myre-nav-icon-btn',
  templateUrl: './navbar-icon-btn.component.html',
  styleUrls: ['./navbar-icon-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent],
})
export class NavbarIconBtnComponent {
  public readonly icon = input.required<string>();
  public readonly numberOfNotifications = input<number | null>(null);

  @Output()
  public onClick = new EventEmitter<Event>();

  protected readonly ButtonHeight = ButtonHeight;
  protected readonly ButtonTheme = ButtonTheme;
}
